import { gsap, Back, Power2, Elastic } from "gsap";

export const Timeline = function (isActive, isVertical, isLeft) {
    this.isActive = isActive;
    this.ctx = null;
    this.canvas = null;
    this.gallery = null;
    this.yearLines = [];
    this.monthLines = [];
    this.visibleYears = [];
    this.visibleMonths = [];
    this.currentDate = null;
    this.animationTimer = 0;
    this.isAnimating = false;
    this.monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    this.monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    this.isFirstLoad = isVertical ? false : true;

    this.isVertical = isVertical;
    this.isLeft = isLeft;
    this.filteredYears = [];
    this.centerLine = {
        x: 0,
        top: 250,
        height: isVertical ? 350 : 400,
        offset: {
            x: 0,
            y: 0,
            opacity: 1,
            textY: 0,
        },
        momentsInMonth: 0,
    };
    this.scroll = {
        x: 0,
        y: 0,
        length: 0,
    };
    this.mostPopularMonth = 1;
    this.config = {
        width: 40,
        height: isVertical ? 120 : 160,
        minHeight: 10,
        increment: null,
        yearLineColour: "rgba(68, 112, 182, 0.25)",
        monthLineColour: "#333E48",
        yearLarge: {
            font: "normal 800 400px Avenir",
            colour: "#E1EAF9",
        },
        yearLabel: {
            font: "normal 800 40px Avenir",
            colour: "#000000",
        },
        monthLabel: {
            font: "normal 400 24px Avenir",
            colour: "#605FB2",
        },
        centerLabel: {
            font: "normal 800 24px Avenir",
            fontSmall: "normal 800 20px Avenir",
            colour: "#605FB2",
        },
    };

    if (window.innerHeight < 980) {
        this.centerLine.height = isVertical ? 300 : 280;
        this.config.height = 120;
        this.centerLine.top = 200;
    }

    this.init = (_currentDate, _filteredYears, _Gallery) => {
        this.canvas.width = this.canvas.offsetWidth * 2;
        this.canvas.height = this.canvas.offsetHeight * 2;
        this.gallery = _Gallery;
        this.ctx = this.canvas.getContext("2d");
        this.currentDate = new Date(_currentDate);
        this.filteredYears = _filteredYears;

        this.getIncrement();

        this.yearLines = [];
        this.monthLines = [];

        // create year / month objects, that
        // with x,y,height,strokeWidth values
        // which can be animated.
        let lineX = 0;
        this.filteredYears.map((year) => {
            year.months.map((month) => {
                if (month.month === 0) {
                    // ADD YEAR LINE
                    this.yearLines.push({
                        x: lineX,
                        height: this.config.height + 20,
                        width: 2,
                        colour: "#C3D2E8",
                        offset: {
                            y: 0,
                            width: 0,
                            textY: 0,
                            opacity: 1,
                        },
                        label: year.year,
                        year: year.year,
                    });
                }
                // ADD MONTH LINE
                const _m = {
                    x: lineX,
                    momentsLength: month.moments.length,
                    height: this.config.minHeight + month.moments.length * this.config.increment,
                    width: 2,
                    colour: month.moments.length > 0 ? "#333E48" : "#C3D2E8",
                    offset: {
                        y: 0,
                        width: 0,
                    },
                    year: year.year,
                    month: month.month,
                };

                // console.log("MONTH >> ", _m);
                this.monthLines.push(_m);
                if (this.isVertical) {
                    lineX -= this.config.width;
                } else {
                    lineX += this.config.width;
                }

                return null;
            });
            return null;
        });

        this.updateScrollPosition();
        this.setVisibleLines();
        if (this.isActive) {
            this.showTimeline();
        }
    };

    // MOUSE FUNCTIONS -----------------
    this.onClick = (e) => {
        console.log("timeline click", e);
    };
    this.onMouseMove = (e) => {
        console.log("timeline mouse move", e);
    };
    // END MOUSE FUNCTIONS

    this.getIncrement = () => {
        // the maximum number of momenets per month.
        // Use this value to determine how to increment
        // moment density lines.
        this.filteredYears.map((year) => {
            year.months.map((month) => {
                if (month.moments.length > this.mostPopularMonth) {
                    this.mostPopularMonth = month.moments.length;
                }
                return null;
            });
            this.scroll.length += this.config.width * year.months.length;
            return null;
        });
        this.config.increment = (this.config.height - this.config.minHeight) / this.mostPopularMonth;
    };

    this.setDate = (date) => {
        // gallery.setDate
        const _date = new Date(date);
        if (_date !== this.currentDate) {
            this.currentDate = _date;
            this.updateScrollPosition(0.5);
        }
    };

    this.setAnimationTimer = (seconds) => {
        this.isAnimating = true;
        window.requestAnimationFrame(this.update);
        clearTimeout(this.animationTimer);
        this.animationTimer = setTimeout(() => {
            this.isAnimating = false;
        }, seconds * 1000);
    };

    this.setVisibleLines = () => {
        // only render years and months within the view port
        if (this.isVertical) {
            this.visibleYears = this.yearLines.filter((year) => year.x - this.scroll.x > this.canvas.height * -0.5 && year.x - this.scroll.x < this.canvas.height * 0.5);
            this.visibleMonths = this.monthLines.filter((month) => month.x - this.scroll.x > this.canvas.height * -0.5 && month.x - this.scroll.x < this.canvas.height * 0.5);
        } else {
            this.visibleYears = this.yearLines.filter((year) => year.x - this.scroll.x > this.canvas.width * -0.5 && year.x - this.scroll.x < this.canvas.width * 0.5);
            this.visibleMonths = this.monthLines.filter((month) => month.x - this.scroll.x > this.canvas.width * -0.5 && month.x - this.scroll.x < this.canvas.width * 0.5);
        }
    };

    // update moments data
    this.updateData = (_filteredYears) => {
        this.data = [..._filteredYears];
        // todo: UPDATE
        console.log("todo: update canvas, based on new data from _filteredYears");
    };

    this.findCurrentMonth = () => {
        return this.monthLines.find((month) => month.year === this.currentDate.getFullYear() && month.month === this.currentDate.getMonth());
    };

    this.updateScrollPosition = (seconds) => {
        const _month = this.findCurrentMonth();

        if (seconds) {
            this.setAnimationTimer(0.5);
            gsap.to(this.scroll, { x: _month.x, duration: 0.45, ease: Power2.easeOut });
        } else {
            this.scroll.x = _month.x;
            this.update();
        }
    };

    this.showTimeline = () => {
        const _delay = this.isFirstLoad ? 1.5 : 0;

        gsap.fromTo(this.centerLine.offset, { y: this.centerLine.height }, { y: 0, duration: 0.3, ease: Back.easeOut, delay: _delay });
        gsap.fromTo(this.centerLine.offset, { opacity: 0, fontY: 10 }, { opacity: 1, fontY: 0, duration: 0.3, ease: Back.easeOut, delay: 0.2 + _delay });

        this.visibleYears.map((line, i) => {
            gsap.fromTo(line.offset, { y: line.height, opacity: 0, textY: 10 }, { y: 0, opacity: 1, textY: 0, duration: 0.25, ease: Power2.easeOut, delay: _delay + 0.2 + i * 0.05 });
            return null;
        });

        this.visibleMonths.map((line) => {
            gsap.fromTo(line.offset, { y: line.height }, { y: 0, duration: 0.4, ease: Back.easeOut, delay: Math.random() * 0.2 + 0.3 + _delay });
            return null;
        });

        this.setAnimationTimer(1.0 + _delay);
        this.isFirstLoad = false;
    };

    this.hideTimeline = () => {
        // gsap.fromTo(this.centerLine, { height: 0, duration: 0.3, ease: Power2.easeIn });

        this.visibleYears.map((line) => {
            gsap.to(line.offset, { y: line.height + 5, opacity: 0, textY: 10, duration: 0.25, ease: Power2.easeIn });
            return null;
        });

        this.visibleMonths.map((line) => {
            gsap.to(line.offset, { y: line.height + 5, duration: 0.3, ease: Power2.easeIn });
            return null;
        });

        gsap.to(this.centerLine.offset, { y: this.centerLine.height, opacity: 0, fontY: 10, duration: 0.3, ease: Power2.easeIn });

        this.setAnimationTimer(0.3);
    };

    // DRAW MONTH LINES ---------------
    this.drawMonth = (line) => {
        this.ctx.beginPath();
        if (this.isVertical) {
            if (this.isLeft) {
                this.ctx.moveTo(0, line.x - this.scroll.x);
                this.ctx.lineTo(-line.height + line.offset.y, line.x - this.scroll.x);
            } else {
                this.ctx.moveTo(0, line.x - this.scroll.x);
                this.ctx.lineTo(line.height - line.offset.y, line.x - this.scroll.x);
            }
        } else {
            this.ctx.moveTo(line.x - this.scroll.x, 0);
            this.ctx.lineTo(line.x - this.scroll.x, -line.height + line.offset.y);
        }

        this.ctx.lineCap = "round";
        this.ctx.strokeStyle = line.colour;
        this.ctx.lineWidth = line.width;
        this.ctx.stroke();
        this.ctx.closePath();
    };

    // DRAW YEAR LINES ---------------
    this.drawYear = (line) => {
        const notCurrentYearJanuary = this.currentDate.getFullYear() !== line.year || this.currentDate.getMonth() !== 0;
        this.ctx.beginPath();

        if (this.isVertical) {
            // check if year is current Year January (to prevent overlap)
            if (notCurrentYearJanuary) {
                if (this.isLeft) {
                    this.ctx.moveTo(0, line.x - this.scroll.x);
                    this.ctx.lineTo(-line.height + line.offset.y, line.x - this.scroll.x);
                } else {
                    this.ctx.moveTo(0, line.x - this.scroll.x);
                    this.ctx.lineTo(line.height - line.offset.y, line.x - this.scroll.x);
                }
            }
        } else {
            this.ctx.moveTo(line.x - this.scroll.x, 0);
            this.ctx.lineTo(line.x - this.scroll.x, -line.height + line.offset.y);
        }

        this.ctx.lineCap = "round";
        this.ctx.strokeStyle = line.colour;
        this.ctx.lineWidth = line.width;
        this.ctx.stroke();
        this.ctx.closePath();
        if (line.height > 20) {
            if (this.isVertical) {
                // check if year is current Year January (to prevent overlap)
                if (notCurrentYearJanuary) {
                    if (this.isLeft) {
                        this.ctx.ellipse(-line.height + line.offset.y, line.x - this.scroll.x, 5, 5, 0, 0, Math.PI * 2);
                    } else {
                        this.ctx.ellipse(line.height - line.offset.y, line.x - this.scroll.x, 5, 5, 0, 0, Math.PI * 2);
                    }
                }
            } else {
                this.ctx.ellipse(line.x - this.scroll.x, -line.height + line.offset.y, 5, 5, 0, 0, Math.PI * 2);
            }
        }
        this.ctx.fillStyle = "#C3D2E8";
        this.ctx.fill();

        this.ctx.fillStyle = this.config.yearLabel.colour;
        this.ctx.font = this.config.yearLabel.font;
        this.ctx.globalAlpha = line.offset.opacity;
        this.ctx.textAlign = "left";

        if (this.isVertical) {
            // check if year is current Year January (to prevent overlap)
            if (notCurrentYearJanuary) {
                if (this.isLeft) {
                    this.ctx.textAlign = "right";
                    this.ctx.fillText(line.label, -line.height + line.offset.y - 20, line.x - this.scroll.x + 15 + line.offset.textY, 400);
                } else {
                    this.ctx.fillText(line.label, line.height - line.offset.y + 20, line.x - this.scroll.x + 15 + line.offset.textY, 400);
                }
            }
            //
        } else {
            this.ctx.fillText(line.label, line.x - this.scroll.x + 20, -line.height + line.offset.y + 10 + line.offset.textY, 400);
        }
        this.ctx.globalAlpha = 1;
    };

    // DRAW CENTER LINE ---------------
    this.drawCenterLine = () => {
        this.ctx.beginPath();
        if (this.isVertical) {
            if (this.isLeft) {
                this.ctx.moveTo(0, this.scroll.x - this.scroll.x);
                this.ctx.lineTo(-this.centerLine.height + this.centerLine.offset.y, this.scroll.x - this.scroll.x);
            } else {
                this.ctx.moveTo(0, this.scroll.x - this.scroll.x);
                this.ctx.lineTo(this.centerLine.height - this.centerLine.offset.y, this.scroll.x - this.scroll.x);
            }
        } else {
            this.ctx.moveTo(this.scroll.x - this.scroll.x, 0);
            this.ctx.lineTo(this.scroll.x - this.scroll.x, -this.centerLine.height + this.centerLine.offset.y);
        }
        this.ctx.lineCap = "round";
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = "#C3D2E8";
        this.ctx.stroke();
        this.ctx.closePath();

        if (this.centerLine.height > 20) {
            if (this.isVertical) {
                if (this.isLeft) {
                    this.ctx.ellipse(-this.centerLine.height + this.centerLine.offset.y, this.scroll.x - this.scroll.x, 5, 5, 0, 0, Math.PI * 2);
                } else {
                    this.ctx.ellipse(this.centerLine.height - this.centerLine.offset.y, this.scroll.x - this.scroll.x, 5, 5, 0, 0, Math.PI * 2);
                }
            } else {
                this.ctx.ellipse(this.scroll.x - this.scroll.x, -this.centerLine.height + this.centerLine.offset.y, 5, 5, 0, 0, Math.PI * 2);
            }
        }
        this.ctx.fillStyle = "#C3D2E8";
        this.ctx.fill();

        // label
        this.ctx.fillStyle = this.config.centerLabel.colour;
        this.ctx.globalAlpha = this.centerLine.offset.opacity;
        const currentMonth = this.findCurrentMonth();

        if (this.isVertical) {
            this.ctx.font = this.config.centerLabel.fontSmall;
            if (this.isLeft) {
                this.ctx.textAlign = "left";
                this.ctx.clearRect(-310, -10, 200, 20);
                const monthLabel = this.monthNamesShort[this.currentDate.getMonth()] + `(${currentMonth.momentsLength} moments)`;
                this.ctx.fillText(monthLabel, -300, 6, 200);
            } else {
                this.ctx.textAlign = "right";
                this.ctx.clearRect(110, -10, 200, 20);
                const monthLabel = this.monthNamesShort[this.currentDate.getMonth()] + `(${currentMonth.momentsLength} moments)`;
                this.ctx.fillText(monthLabel, 300, 6, 200);
            }
        } else {
            this.ctx.font = this.config.centerLabel.font;
            this.ctx.textAlign = "center";
            this.ctx.clearRect(-100, -this.centerLine.top - 35, 200, 60);
            const monthLabel = this.monthNames[this.currentDate.getMonth()] + ` (${currentMonth.momentsLength} moments)`;
            this.ctx.fillText(monthLabel, 0, -this.centerLine.top, 400);
        }

        this.ctx.globalAlpha = 1;
    };

    this.update = () => {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        if (this.isActive) {
            this.ctx.save();
            this.ctx.shadowBlur = 0;
            this.ctx.shadowOffsetY = 0;

            if (this.isVertical) {
                if (this.isLeft) {
                    // console.log("VERTICAL LEFT");
                    this.ctx.translate(this.canvas.width, this.canvas.height * 0.5);
                } else {
                    // console.log("VERTICAL RIGHT");
                    this.ctx.translate(0, this.canvas.height * 0.5);
                }
            } else {
                // console.log("DEFAULT VIEW");
                this.ctx.translate(this.canvas.width * 0.5, this.canvas.height);
            }

            this.drawCenterLine();

            this.setVisibleLines();

            // Draw years
            this.visibleYears.map((line) => this.drawYear(line));

            // Draw months
            this.visibleMonths.map((line) => this.drawMonth(line));

            this.ctx.restore();
        }
        if (this.isAnimating) {
            window.requestAnimationFrame(this.update);
        }
    };
};
